$avatar-large-size: 56px;
$avatar-default-size: 40px;
$avatar-small-size: 32px;
$avatar-xsmall-size: 22px;

.avatar {
  background: var(--cxy-color-surface-page);
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  box-shadow: var(--cxy-box-shadow-a);
  overflow: hidden;
  flex-shrink: 0;
  padding: var(--cxy-spacing-xxxsm);

  &.xsmall {
    padding: var(--cxy-spacing-0);
  }
}

.xsmall {
  height: $avatar-xsmall-size;
  width: $avatar-xsmall-size;
}

.small {
  height: $avatar-small-size;
  width: $avatar-small-size;
}

.medium {
  height: $avatar-default-size;
  width: $avatar-default-size;
}

.large {
  height: $avatar-large-size;
  width: $avatar-large-size;
}

.avatarImage {
  height: 100%;
  width: 100%;
  object-fit: cover;

  &.personAvatarImage {
    transform: scale(1.35);
    margin-block-end: calc(var(--cxy-spacing-xxxsm) * -1);
  }

  &.teamLogoImage {
    height: 93%;
    width: 93%;
  }
}

.teamAvatars {
  display: flex;

  :nth-child(2) {
    margin-inline-start: calc($avatar-small-size / 3 * -1);
    margin-block-start: calc($avatar-small-size / 3);
    z-index: 2;
  }
}

.personAvatar {
  position: relative;
  height: $avatar-default-size;
  width: $avatar-default-size;

  .playerAvatarTeamImage {
    background: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    height: 35%;
    width: 35%;
    bottom: 0;
    right: 0;

    img {
      height: 90%;
      width: 90%;
      object-fit: contain;
    }
  }
}

.placeholder {
  height: 100%;
  width: 100%;
  object-fit: contain;
}
